// tslint:disable
import { GeoJsonLayer, TextLayer, ScatterplotLayer } from '@deck.gl/layers';
import { BaseLayerGeoJSONDeck } from '../../common/layers/baseLayerGeoJSONDeck';
import { LAYERS_ID, LAYERS_SQL } from './constants';
import * as turf from '@turf/turf';
import { MapContextService } from 'app/common/map-context.service';
import { HistoricContextService } from 'app/historic/historic-context.service';
// tslint:enable

export class EditableLayer extends BaseLayerGeoJSONDeck {
  poisLayerSourceVisible = [];
  poisLayerTypeVisible = [];
  data = null;
  processedPoints = [];
  points = [];
  featureCollection = {
      type: 'FeatureCollection',
      features: []
  };
  zoom = 11;
  //   icon_atlas = '';
  layerData: any;
  //   icon_mapping: any;
  icon: string;
  /* eslint-disable */
  mapContext: MapContextService;


  layers = {
    [LAYERS_ID.WAZE_BCN_EDITABLE_GEOJSON_LAYER]: new GeoJsonLayer({
      id: LAYERS_ID.WAZE_BCN_EDITABLE_GEOJSON_LAYER,
      data: this.polygon(),
      getLineColor: [4, 82, 117],
      filled: true,
      lineWidthScale: 10,
      lineWidthMinPixels: 1,
      lineWidthMaxPixels: 5,
      getFillColor: [8, 144, 153, 20],
      opacity: 0.8,
      pickable: true,
    }),
    [LAYERS_ID.WAZE_BCN_EDITABLE_SCARLET_LAYER]: new ScatterplotLayer({
      id: LAYERS_ID.WAZE_BCN_EDITABLE_SCARLET_LAYER,
      data: this.data ? this.data.features : null,
      stroked: true,
      getPosition: d => d.geometry.coordinates,
      getFillColor: d => d.properties.helper ? [255, 255, 255] : [4, 82, 117],
      getLineColor: [0, 0, 0],
      lineWidth: 2,
      lineWidthMinPixels: 2,
      lineWidthMaxPixels: 10,
      radiusUnits: 'pixels',
      radiusScale: 2,
      radiusMinPixels: 5,
      radiusMaxPixels: 15,
      pickable: true,
      onDragStart: (e) => {
        this.mapContext.deckInstance.setProps({controller: false})
      },
      onDrag: (e: any) => {
        if ( e.coordinate) {
            if (e.object.properties.helper) {
                this.points.splice(e.object.properties.id, 0, e.coordinate);
                e.object.properties.helper = false;
            } else {
                this.points[e.object.properties.id] = e.coordinate;
            }
            this.updateSource(e, true);
        }
    },
    onDragEnd: (e) => {
        this.mapContext.deckInstance.setProps({controller: true})
    }
    })
  };
/* eslint-enable */

  constructor(private  historicContextService: HistoricContextService) {
    super(LAYERS_ID.WAZE_BCN_EDITABLE_LAYER);
    this.data = this.getGeojson();
  }

  updateSource(event, drag = false) {

    if (event && !drag) {
      this.points.push(event.coordinate);
    } else if (!drag) {
      this.points = [];
    }
    this.processHelperPoints();

    const data = this.getGeojson();
    this.data = data;

    this.update(LAYERS_ID.WAZE_BCN_EDITABLE_GEOJSON_LAYER, {
      data: this.polygon(),
    });

    this.update(LAYERS_ID.WAZE_BCN_EDITABLE_SCARLET_LAYER, {
      data: this.data ? this.data.features : null,
    });

    const filters = this.historicContextService.getFilters();
    filters.customBBOX = [].concat.apply([], this.polygon().geometry.coordinates[0]);
    this.historicContextService.setFilters(filters);
    // return this.polygon();

  }

  updateState() {}

  _getPosition(d) {
    return d.geometry.coordinates
  }

  polygon() {
    if (!this.data) {
      return null;
    }
    return {
        type: 'Feature',
        geometry: {
            type: 'Polygon',
            coordinates: [this.data.features.filter(item => !item.properties.helper).map(item => item.geometry.coordinates)]
        }
    }
  }

  addPoint(coords, isHelperPoint, idx) {
    this.processedPoints.push({
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: coords
        },
        properties: {
            helper: isHelperPoint,
            id: idx
        }
    });
  }

  processHelperPoints() {
    this.processedPoints = [];
    this.points.forEach((point, idx) => {
        if (idx === 0) {
            this.addPoint(point, false, idx);
        } else {
            const center = turf.center(turf.featureCollection([
                turf.point(point),
                turf.point(this.points[idx - 1])
            ]));
            this.addPoint(center.geometry.coordinates, true, idx);
            this.addPoint(point, false, idx);
            if (idx === this.points.length - 1) {
                const lastFirstCenter = turf.center(turf.featureCollection([
                    turf.point(point),
                    turf.point(this.points[0])
                ]));
                if (JSON.stringify(center.geometry.coordinates) !== JSON.stringify(lastFirstCenter.geometry.coordinates)) {
                    this.addPoint(lastFirstCenter.geometry.coordinates, true, idx + 1);
                }
            }
        }
    });
  }

  getGeojson() {
    const featureCollection = {
        type: 'FeatureCollection',
        features: []
    };

    if (this.processedPoints.length) {
        featureCollection.features = [
            ...this.processedPoints,
            this.processedPoints[0]
        ];
    }
    return featureCollection;
}

  async getData() {
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/historic/layers/editableLayer.ts